import React, { Component } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import ProjectsComponent from '../../components/Projects';
import { BASE_URL } from '../../constants';

class Projects extends Component {
  static LIST_PROJECTS_URL = `${BASE_URL}/projects/portfolio-mujz/databases/(default)/documents/projects/`

  state = {
    isLoading: true,
    projects: null,
  }

  componentDidMount() {
    this.fetchProjects()
  }

  async fetchProjects() {
    const response = await fetch(Projects.LIST_PROJECTS_URL);
    const projects = await response.json();
    this.setState({ projects: projects.documents, isLoading: false });
  }

  async updateFavoritesCount(projectResourceName, favoritesCount) {
    const updateURL = `${BASE_URL}/${projectResourceName}?currentDocument.exists=true&updateMask.fieldPaths=favoritesCount`
    await fetch(updateURL, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fields: {
          favoritesCount: {
            integerValue: JSON.stringify(favoritesCount),
          },
        },
      }),
    });
  }

  render() {
    if (this.state.isLoading) {
      return (<LinearProgress />)
    }

    return (
      <ProjectsComponent
        projects={this.state.projects}
        updateFavoritesCount={this.updateFavoritesCount}
      />
    )
  }
}

export default Projects;
